import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    counterOfErrors500: 0,
    innerSport: 6046,
    navigation: false,
    events: [],
    sports: [],
    data_events: {},
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "",
    coupons: [],
    markets: [],
    results: [],
    feedback: "",
    print: {},
    logged: {
      status: false,
    },
    cash: "",
    cashBonus: {
      value: "",
      status: "",
    },
    userId: "",
    operators: {},
    subTitlePages: "",
    infoSportsMarkets: null,
    infoSportsMarketsLive: null,
    nextEvents: null,
    appVersionVuex: null,
    lastBetAmount: 5,
    bbbParticipants: [],
    dialogEvent: false,
    // leftMenu: {
    //   time: null,
    //   events: []
    // },
    // Agent
    betCard: "",
    betAgent: "",
    betAgentDialog: false,
    feedbackDialog: "",
    feedbackSnack: "",
    feedbackProgress: false,
    shareBet: false,
    hitoricBetResult: 2,
    permission_reward: "",
    affiliateCpaType: "0", // 0 - sem comissão de CPA, 1 - CPA fixo, 2 - CPA percentual
    //Deposit Validate Promotion
    dialogValidatePromotion: false,

    // Show migration data
    showMigrationUserLoginMessage: false,

    //Deposit Financial
    dialogDeposit: false,
    dialogQrcode: {
      status: false,
      obj: "",
    },
    dialogWithdrawal: false,
    dialogBetOnline: {
      status: false,
      value: "",
    },
    tableBank: false,

    // Abrir dialog pela 1º e única vez enquanto logado
    dialogGreetingsPromotionsFirstTime: true,

    // ====================================================
    // RangeDate
    range: {
      enable: false,
      date: {
        date_start: "",
        date_final: "",
      },
    },
    language: "",
    flagLanguage: "",

    breakpointName: "",
    // Tempo de uso do usuário final
    userTimeLimit: "",
    dialogTimeActivity: false,
    // Mensagens ao usuário
    messagesNotRead: 0,

    // ********* DASHBOARDS ***********//
    progressLinear: false,

    // ====================================================
    // RangeDate Filters Global ********** NEW ************
    rangeGlobal: {
      enable: false,
      select: "",
      date: {
        date_start: "",
        date_final: "",
      },
      date_start_br: "",
      date_end_br: "",
      time_start: "",
      time_end: "",
      disabled: false,
    },
    rangeUI: "",
    // ====================================================
    // Filters State Default ********** NEW ************
    filters: {
      enableWrap: false,
      save: false,
      disabledSave: false,
      autocompleteNamePlayers: {
        enable: false,
        player_name: "",
      },
      selectResultBet: {
        enable: false,
        result: "",
      },
      selectStatusBetOnline: {
        enable: false,
        status: "",
      },
      eventNumber: {
        enable: false,
        value: "",
      },
      gamingType: {
        enable: false,
        value: "",
      },
      groupExport: {
        enable: false,
        value: "", // Site: '', Excel: 1
      },
      paymentMonth: {
        enable: false,
        text: "",
        value: (() => {
          let d = new Date(new Date().setMonth(new Date().getMonth() - 1));
          return new Date(d - d.getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 7);
        })(),
        disabled: false,
      },
      casinoRange: {
        enable: false,
        text: "",
        value: "last24Hours",
        option: 0,
        customRange: {
          from: "",
          to: "",
        },
      },
      casinoBetsStatus: {
        enable: false,
        selected: [],
        value: "",
      },
    },

    // ********* END / DASHBOARDS ***********//
    // Show Dialog GENÉRICO
    showDialog: false,
    // Show Dialog Register
    showDialogRegister: false,
    showDialogRegisterByIdDialog: "", // (general|appbar|desktopGame|mobileGame|itemDialog|unloggedDialog)
    // Show Dialog Confirm Registar
    showDialogConfirmRegister: false,
    showDialogPhoneOrEmailChangeConfirmation: false,
    // Show Dialog Token e Dialog Confirm Token
    showDialogToken: false,
    showDialogConfirmToken: false,

    // Favorites
    favoriteTournaments: [],
    favoriteMarkets: [],

    // Style Format Grid Odds
    styleFlexWrapOdds: "flex-row",
    openCouponAfterExpiredEventsFeedback: false,

    // Motive P4Fun
    motiveDialog: false,

    currentDepositPromotionCode: null,
    currentRegisterPromotionCode: null,

    verificationSteps: [],

    // Data games category
    dataCasinoGamesCategories: [],

    bigTableMarkets: [],

    currentCategory: "",

    casinoLeftMenu: [],
    casinoProviders: [],
    casinoCurrentGameMobile: null,
    fetchingCasinoLobby: false,
    casinoFilters: {
      alphabeticalOrder: "A - Z",
      providers: [],
    },

    openLoginDialog: false,
    userIp: "",
    openMenu: null,

    modeViewGame: "",
    changePasswordDialog: false,
    indexedDbFetching: false,

    dialogBlockUser: {
      status: false,
      idReason: "",
      messageReason: "",
    },

    gamesFavoritesUpdating: false,

    exemptedPlayer: {
      has_exempt_player: false,
    },

    dialogVerifySmsToken: {
      status: false,
      typeVerification: "", // (phone_verification|twoStepsAuthentication)
    },
    availableBalance: "",
    restrictedBalance: "",
  },
  plugins: [createPersistedState()],
  mutations: {
    setCasinoCurrentGameMobile(state, game) {
      state.casinoCurrentGameMobile = game;
    },
    showDialog(state, bool) {
      state.showDialog = bool;
    },
    showDialogRegister(state, bool) {
      state.showDialogRegister = bool;
    },
    showDialogRegisterByIdDialog(state, str) {
      state.showDialogRegisterByIdDialog = str;
    },
    showDialogConfirmRegister(state, bool) {
      state.showDialogConfirmRegister = bool;
    },
    showDialogPhoneOrEmailChangeConfirmation(state, bool) {
      state.showDialogPhoneOrEmailChangeConfirmation = bool;
    },
    showDialogToken(state, bool) {
      state.showDialogToken = bool;
    },
    showDialogConfirmToken(state, bool) {
      state.showDialogConfirmToken = bool;
    },
    permission_reward(state, n) {
      state.permission_reward = n;
    },
    setUserTimeLimit(state, string) {
      state.userTimeLimit = string;
    },
    showDialogTimeActivity(state, bool) {
      state.dialogTimeActivity = bool;
    },
    hitoricBetResult(state, n) {
      state.hitoricBetResult = n;
    },
    innerSport(state, n) {
      state.innerSport = n;
    },
    appVersionVuex(state, n) {
      state.appVersionVuex = n;
    },
    nextEvents(state, n) {
      state.nextEvents = n;
    },
    data_events(state, n) {
      state.data_events = n;
    },
    data_events_copy(state, n) {
      state.data_events_copy = n;
    },
    subTitlePages(state, n) {
      state.subTitlePages = n;
    },
    print(state, print) {
      state.print = print;
    },
    navigation(state, navigation) {
      state.navigation = navigation;
    },
    setLogged(state, logged) {
      state.logged = logged;
    },
    setCash(state, cash) {
      state.cash = cash;
    },
    setAvailableBalance(state, value) {
      state.availableBalance = value;
    }, 
    setRestrictedBalance(state, value) {
      state.restrictedBalance = value;
    }, 
    setBonus(state, obj) {
      state.cashBonus = obj;
    },
    setUserId(state, number) {
      state.userId = number;
    },
    setAffiliateCpaType(state, number) {
      state.affiliateCpaType = number;
    },
    resetUser(state) {
      state.user = null;
      state.logged = false;
    },
    setNotification(state, obj) {
      if (!state.showSnackbar) {
        state.showSnackbar = true;
        state.snackbarMessage = obj.msg;
        state.snackbarColor = obj.color;
      }
    },
    setFeedback(state, data) {
      state.feedback = data;
    },
    resetNotification(state) {
      state.showSnackbar = false;
      state.snackbarMessage = "";
      state.snackbarColor = "";
    },
    setCoupons(state, coupons) {
      state.coupons = coupons;
    },
    setMarkets(state, markets) {
      state.markets = markets;
    },
    setResults(state, results) {
      state.results = results;
    },
    setSports(state, sports) {
      state.sports = sports;
    },
    setOperators(state, operators) {
      state.operators = operators;
    },
    setInfoSportsMarkets(state, info) {
      state.infoSportsMarkets = info;
    },
    setInfoSportsMarketsLive(state, info) {
      state.infoSportsMarketsLive = info;
    },
    setLastBetAmount(state, val) {
      state.lastBetAmount = val;
    },
    setDialogEvent(state, bool) {
      state.dialogEvent = bool;
    },
    // Agent
    setBetCard(state, data) {
      state.betCard = data;
    },
    setBetAgent(state, data) {
      state.betAgent = data;
    },
    setBetAgentDialog(state, data) {
      state.betAgentDialog = data;
    },
    setFeedbackDialog(state, data) {
      state.feedbackDialog = data;
    },
    setFeedbackSnack(state, data) {
      state.feedbackSnack = data;
    },
    setFeedbackProgress(state, data) {
      state.feedbackProgress = data;
    },
    setShareBet(state, data) {
      state.shareBet = data;
    },
    specialSports(state, arrSpecialSports) {
      const bbbParticipants = arrSpecialSports[0].categories[0].tournaments[0].events[0].odds.map(
        (participant) => participant.legend
      );
      state.bbbParticipants = bbbParticipants;
    },

    // User Credit Online
    dialogDeposit(state, bool) {
      state.dialogDeposit = bool;
    },

    dialogWithDrawal(state, bool) {
      state.dialogWithdrawal = bool;
    },
    SetRangeDate(state, object) {
      // format: "2021-02-05T00:00:00.399" (ISO)
      state.range.date = object;
    },
    showBetDialog(state, obj) {
      state.dialogBetOnline.status = obj.status;
      state.dialogBetOnline.value = obj.value;
    },
    showDialogQrcode(state, obj) {
      state.dialogQrcode.obj = obj.obj;
      state.dialogQrcode.status = obj.status;
    },
    refreshTableBank(state, bool) {
      state.tableBank = bool;
    },
    showDialogGreetingsPromotionsFirstTime(state, bool) {
      state.dialogGreetingsPromotionsFirstTime = bool;
    },
    // setLeftMenu(state, obj) {
    //   state.leftMenu = obj
    // },
    setLanguage(state, string) {
      state.language = string;
    },
    setFlagLanguage(state, string) {
      state.flagLanguage = string;
    },
    setBreakpointName(state, name) {
      state.breakpointName = name;
    },

    // *************** DASHBOARD *************** //
    setProgressLinear(state, bool) {
      state.progressLinear = bool;
    },

    // Filters Global ************** NEW ***************
    // ====================================================
    // Range
    RangeGlobal(state, bool) {
      state.rangeGlobal.enable = bool;
    },
    SetRangeGlobalDate(state, object) {
      // format: "2021-02-05T00:00:00.399" (ISO)
      state.rangeGlobal.date = object;
    },
    SetRangeGlobalSelect(state, object) {
      // format obj: {label: "",value: "",}
      state.rangeGlobal.select = object;
    },
    SetDateStartBr(state, string) {
      state.rangeGlobal.date_start_br = string;
    },
    SetDateEndBr(state, string) {
      state.rangeGlobal.date_end_br = string;
    },
    SetTimeStart(state, string) {
      state.rangeGlobal.time_start = string;
    },
    SetTimeEnd(state, string) {
      state.rangeGlobal.time_end = string;
    },
    setDisabledRange(state, bool) {
      state.rangeGlobal.disabled = bool;
    },
    setRangeGlobalUI(state, data) {
      state.rangeUI = data;
    },
    // ====================================================
    // Filters: Enable
    FiltersWrap(state, bool) {
      state.filters.enableWrap = bool;
    },
    AutocompleteNamePlayers(state, bool) {
      state.filters.autocompleteNamePlayers.enable = bool;
    },
    SelectResultBet(state, bool) {
      state.filters.selectResultBet.enable = bool;
    },
    EventNumber(state, bool) {
      state.filters.eventNumber.enable = bool;
    },
    GamingType(state, bool) {
      state.filters.gamingType.enable = bool;
    },
    PaymentMonth(state, bool) {
      state.filters.paymentMonth.enable = bool;
    },
    SelectStatusBetOnline(state, bool) {
      state.filters.selectStatusBetOnline.enable = bool;
    },
    GroupExport(state, bool) {
      state.filters.groupExport.enable = bool;
    },
    // ====================================================
    // Filters: Set
    DisabledSave(state, bool) {
      state.filters.disabledSave = bool;
    },
    // Filters: Set data
    setSave(state, bool) {
      state.filters.save = bool;
    },
    setSelectResultBet(state, result) {
      state.filters.selectResultBet.result = result;
    },
    setPlayerName(state, name) {
      state.filters.autocompleteNamePlayers.player_name = name;
    },
    setSelectStatusBetOnline(state, status) {
      state.filters.selectStatusBetOnline.status = status;
    },
    setEventNumber(state, value) {
      if (value == "" || !isNaN(parseInt(value))) {
        state.filters.eventNumber.value = value;
      }
    },
    setGamingType(state, obj) {
      state.filters.gamingType = { ...state.filters.gamingType, ...obj };
    },
    setPaymentMonth(state, obj) {
      state.filters.paymentMonth = { ...state.filters.paymentMonth, ...obj };
    },
    disablePaymentMonth(state) {
      state.filters.paymentMonth.disabled = true;
    },
    enablePaymentMonth(state) {
      state.filters.paymentMonth.disabled = false;
    },
    setGroupExport(state, value) {
      state.filters.groupExport.value = value;
    },
    setMessagesNotRead(state, number) {
      state.messagesNotRead = number;
    },
    // Validate Promotion Bonus
    dialogValidatePromotion(state, bool) {
      state.dialogValidatePromotion = bool;
    },
    setFavoriteTournaments(state, id_tournament) {
      state.favoriteTournaments.push(id_tournament);
    },
    removeFavoriteTournaments(state, index) {
      state.favoriteTournaments.splice(index, 1);
    },
    setFavoriteMarkets(state, obj) {
      // obj = { id_sport, id_market }
      const favorites = state.favoriteMarkets;
      if (typeof favorites == "object" && favorites.length < 0) {
        state.favoriteMarkets = [];
      }
      state.favoriteMarkets.push(obj);
    },
    removeFavoriteMarkets(state, obj) {
      // obj = { id_sport, id_market }
      state.favoriteMarkets.forEach((item, index) => {
        if (item.id_sport == obj.id_sport && item.id_market == obj.id_market) {
          state.favoriteMarkets.splice(index, 1);
        }
      });
    },
    setCounterOfErrors500(state) {
      state.counterOfErrors500 += 1;
    },
    resetCounterOfErrors500(state) {
      state.counterOfErrors500 = 0;
    },
    setStyleFlexWrapOdds(state, string) {
      state.styleFlexWrapOdds = string;
    },
    setOpenCouponAfterExpiredEventsFeedback(state) {
      state.openCouponAfterExpiredEventsFeedback = !state.openCouponAfterExpiredEventsFeedback;
    },
    setMotiveDialog(state, bool) {
      state.motiveDialog = bool;
    },
    setPaymentMethods(state, payment_methods) {
      state.operators.payment_methods = payment_methods;
    },
    setCurrentDepositPromotionCode(state, currentDepositPromotionCode) {
      state.currentDepositPromotionCode = currentDepositPromotionCode;
    },
    resetCurrentDepositPromotionCode(state) {
      state.currentDepositPromotionCode = null;
    },
    setCurrentRegisterPromotionCode(state, currentRegisterPromotionCode) {
      state.currentRegisterPromotionCode = currentRegisterPromotionCode;
    },
    resetCurrentRegisterPromotionCode(state) {
      state.currentRegisterPromotionCode = null;
    },
    setCustomerIconsSports(state, bool) {
      state.customerIconsSports = bool;
    },
    setCustomerIconsAppbar(state, bool) {
      state.customerIconsAppbar = bool;
    },
    setCustomerIconsSpecial(state, bool) {
      state.customerIconsSpecial = bool;
    },
    setVerificationSteps(state, verificationSteps) {
      state.verificationSteps = verificationSteps;
    },
    setDataCasinoGamesCategories(state, gamesCategories) {
      state.dataCasinoGamesCategories = gamesCategories;
    },
    setBigTableMarkets(state, markets) {
      state.bigTableMarkets = markets;
    },
    setCurrentCategory(state, category) {
      state.currentCategory = category;
    },
    CasinoRange(state, bool) {
      state.filters.casinoRange.enable = bool;
    },
    setCasinoRange(state, { option, item }) {
      state.filters.casinoRange.option = option;
      state.filters.casinoRange.value = item.value;
      state.filters.casinoRange.text = item.text;
    },
    setCasinoCustomRange(state, range) {
      state.filters.casinoRange.customRange = {
        ...state.filters.casinoRange.customRange,
        ...range,
      };
    },
    CasinoBetsStatus(state, bool) {
      state.filters.casinoBetsStatus.enable = bool;
    },
    setCasinoBetsStatus(state, selected) {
      state.filters.casinoBetsStatus.selected = selected;
    },
    setCasinoLeftMenu(state, leftMenu) {
      state.casinoLeftMenu = leftMenu;
    },
    setCasinoProviders(state, providers) {
      state.casinoProviders = providers;
    },
    setFetchingCasinoLobby(state, fetching) {
      state.fetchingCasinoLobby = fetching;
    },
    setCasinoAlphabeticalOrderFilter(state, alphabeticalOrder) {
      state.casinoFilters.alphabeticalOrder = alphabeticalOrder;
    },
    setCasinoProvidersFilter(state, providers) {
      state.casinoFilters.providers = providers;
    },
    setLoginDialog(state, bool) {
      state.openLoginDialog = bool;
    },
    setIp(state, ip) {
      state.userIp = ip;
    },
    setOpenMenu(state, menu) {
      state.openMenu = menu;
    },
    setModeViewGame(state, modeViewGame) {
      state.modeViewGame = modeViewGame;
    },
    showChangePasswordDialog(state, bool) {
      state.changePasswordDialog = bool;
    },
    setIndexedDbFetching(state, bool) {
      state.indexedDbFetching = bool;
    },
    setDialogBlockUser(state, obj) {
      state.dialogBlockUser = obj;
    },
    resetDialogBlockUser(state) {
      state.dialogBlockUser = {
        status: false,
        idReason: "",
        messageReason: "",
      };
    },
    setGamesFavoritesUpdating(state, bool) {
      state.gamesFavoritesUpdating = bool;
    },
    setExemptedPlayer(state, exemptedPlayerData) {
      state.exemptedPlayer = exemptedPlayerData;
    },
    setDialogVerifySmsToken(state, obj) {
      state.dialogVerifySmsToken = obj;
    },
  },
  getters: {
    getCounterOfErrors500: ({ counterOfErrors500 }) => counterOfErrors500,
    getShowSnackbar: (state) => state.showSnackbar,
    getSnackbarMessage: (state) => state.snackbarMessage,
    getSnackbarColor: (state) => state.snackbarColor,
    appVersionVuex: (state) => {
      return state.appVersionVuex;
    },
    nextEvents: (state) => {
      return state.nextEvents;
    },
    getSubTitlePages: (state) => {
      return state.subTitlePages;
    },
    getPrint: (state) => {
      return state.print;
    },
    getFilter: (state) => {
      return state.filter;
    },
    getEvents: (state) => {
      return state.events;
    },
    navigation: (state) => {
      return state.navigation;
    },
    getUser: (state) => {
      return state.user;
    },
    getNotification: (state) => {
      return state.notification;
    },
    getCoupons: (state) => {
      return state.coupons;
    },
    getMarkets: (state) => {
      return state.markets;
    },
    getResults: (state) => {
      return state.results;
    },
    getSports: (state) => {
      return state.sports;
    },
    getOperators: (state) => {
      return state.operators;
    },
    getOperatorSocial: (state) => {
      const operator = state.operators;
      let social = [
        {
          social: operator.facebook ? operator.facebook : false,
          icon: "mdi-facebook",
          url: `https://facebook.com/${operator.facebook}`,
        },
        {
          social: operator.instagram ? operator.instagram : false,
          icon: "mdi-instagram",
          url: `https://instagram.com/${operator.instagram}`,
        },
        {
          social: operator.contact_phone ? operator.contact_phone : false,
          icon: "mdi-whatsapp",
          url: `https://wa.me/${operator.contact_phone}`,
        },
      ];
      return social;
    },

    // Return Total Odds By Coupons
    getTotalOddsByCoupons: (state) => {
      var total_odds = 1;
      state.coupons.forEach((item) => {
        let price =
          item.data.odd_price_margin != undefined
            ? item.data.odd_price_margin
            : item.data.odd_price;
        let multiple = total_odds * Number(price);
        total_odds = multiple;
      });
      return total_odds;
    },
    // Return bool - odd selected by id.
    confirmOddSelectedById: (state) => (id) => {
      return state.coupons.some((item) => item.id_odd === id);
    },

    // Return sport id by name.
    getIdSportByName: (state) => (sportName) => {
      const sport = state.sports.find((item) => item.name_sport === sportName);

      if (sport) {
        return sport.id_sport;
      }

      const allSportsName = [
        ["Futebol", "Fútbol", "Soccer"],
        ["Handebol", "Balonmano", "Handball"],
        ["Basquete", "Baloncesto", "Basketball"],
        ["Tênis", "Tenis", "Tennis"],
        ["Vôlei", "Voleo", "Volley"],
        ["UFC/Boxe", "UFC/Boxeo", "UFC/Boxing"],
        ["Tênis de Mesa", "Tenis de Mesa", "Table Tennis"],
        ["E-Sports"],
        ["Futebol Americano", "Fútbol Americano", "American Football"],
        ["Beisebol", "Béisbol", "Baseball"],
        ["Vôlei de Praia", "Volei de Praia", "Beach Volleyball"],
      ];

      let id = 6046;

      allSportsName.forEach((sports) => {
        if (sports.includes(sportName)) {
          sports.forEach((possibleRightSportName) => {
            const possibleSport = state.sports.find(
              ({ name_sport }) => name_sport === possibleRightSportName
            );

            if (possibleSport) {
              id = possibleSport.id_sport;
            }
          });
        }
      });

      return id;
    },

    // Return item sport by name.
    getSportByName: (state) => (sportName) => {
      return state.sports.filter((item) => item.name_sport === sportName);
    },

    getNameSportById: (state) => (idSport) => {
      const sports = state.sports.filter((item) => item.id_sport === idSport);
      let name_sport = sports[0] && sports[0].name_sport;
      return name_sport;
    },

    // Return array ids markets into Event by Tab active.
    getIdMarketsEventByTab: (state) => (tab) => {
      let items = [];
      const markets = state.markets;
      if (tab === "favoriteMarkets") {
        state.favoriteMarkets.forEach((item) => {
          items.push(item.id_market);
        });
        return items;
      }
      if (tab === "todos") {
        markets.forEach((item) => {
          items.push(item.id_market);
        });
        return items;
      }
      if (tab === "sets") tab = "gols";
      if (tab === "pontos") tab = "gols";
      if (tab === "rodadas") tab = "gols";
      markets.filter((item) => {
        if (item.tab == tab) {
          items.push(item.id_market);
        }
      });
      return items;
    },

    // Return arrays ids markets custom to Table with rules mobile breakpoint
    getIdMarkets: (state) => (idSport, breakpoint, event, type) => {
      const items = [];
      const cols = {
        xl: event ? 1 : 3, // > 1904px*
        lg: event ? 1 : 2, // 1264px* > < 1904px*
        md: event ? 1 : 2, // 960px > < 1264px*
        sm: 1, // 600px > < 960px
        xs: 1, // < 600px
      };

      const mapTypeToFieldName = {
        nextEvents: "infoSportsMarkets",
        live: "infoSportsMarketsLive",
        bigTable: "bigTableMarkets",
      };

      const fieldName = mapTypeToFieldName[type];

      const markets = state[fieldName][idSport];

      const col = cols[breakpoint];
      if (markets) {
        markets.filter((item, index) => {
          if (index <= col - 1) {
            items.push(item);
          }
        });
      }
      return items;
    },
    getShowMigrationUserLoginMessage: (state) => {
      return state.showMigrationUserLoginMessage;
    },

    getVerificationSteps: ({ verificationSteps }) => verificationSteps,

    getDataCasinoGamesCategories: ({ dataCasinoGamesCategories }) =>
      dataCasinoGamesCategories,

    getCurrentCategory: (state) => {
      return state.currentCategory;
    },
    getMonthAndYearOfPayment: (state) => {
      const monthAndYear = state.filters.paymentMonth.value;
      const year = monthAndYear.substr(0, 4);
      const month = monthAndYear.substr(5, 6);
      return { year, month };
    },

    getDialogBlockUserStatus: (state) => {
      return state.dialogBlockUser.status;
    },

    getDialogBlockUserReason: (state) => {
      return {
        id: state.dialogBlockUser.idReason,
        message: state.dialogBlockUser.messageReason,
      };
    },

    getDialogVerifySmsToken: (state) => {
      return {
        status: state.dialogVerifySmsToken.status,
        typeVerification: state.dialogVerifySmsToken.typeVerification,
        // Fluxo Login
        ...(state.dialogVerifySmsToken.login &&
        state.dialogVerifySmsToken.password
          ? {
              login: state.dialogVerifySmsToken.login,
              password: state.dialogVerifySmsToken.password,
            }
          : {}),
        // Atualizando views a partir da Verificação do token, ao verificar
        // será triggado os endpoints (verificationStatus|getPlayer)
        ...(state.dialogVerifySmsToken.trigger
          ? {
              trigger: state.dialogVerifySmsToken.trigger,
            }
          : {}),
        // Fluxo de Verificação do telefone ativando
        // automaticamente Verificação de duas etapas
        ...(state.dialogVerifySmsToken.bothVerification
          ? {
              bothVerification: true,
            }
          : {}),
        // Fluxo de desativação da Verificação de duas etapas
        ...(state.dialogVerifySmsToken.removeTwoStepsAuth
          ? {
              removeTwoStepsAuth: true,
            }
          : {}),
      };
    },
  },
});
